import { Injectable } from '@angular/core';
import {
  BrowseCategoryStoreService,
  ProductAnalyticsService,
  BrowseCategoryState,
} from '@usf/ngrx-product';
import { SearchRequest } from '@usf/product-types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BrowseCategoryService {
  constructor(
    private browseCategoryStoreService: BrowseCategoryStoreService,
    private analyticsService: ProductAnalyticsService,
  ) {}

  executeBrowse(requestParams: SearchRequest): void {
    this.browseCategoryStoreService.executeBrowse(requestParams);
  }

  getCategories(selectorId?: string): Observable<BrowseCategoryState> {
    return this.browseCategoryStoreService.getCategories(selectorId);
  }

  trackCatalogCategoryPageLoad(category: string) {
    this.analyticsService.trackCatalogCategoryPageLoad(category);
  }
}
